import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getDiscountCodes } from '../api'

export const useGetDiscountCodesOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      setStatus('pending')

      try {
        const result = await dispatch(getDiscountCodes())
        if (mounted) {
          if (getDiscountCodes.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) setStatus('fail')
      } finally {
        if (mounted) setStatus('idle')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
